import { render, staticRenderFns } from "./FrequentlyBoughtPP.vue?vue&type=template&id=00d5c19a&"
import script from "./FrequentlyBoughtPP.vue?vue&type=script&lang=js&"
export * from "./FrequentlyBoughtPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports